<template>
    <div class="mb-4">
        <h5 class="py-4 pl-4 mb-0">Mis documentos</h5>
        <b-container fluid class="px-4">
            <b-tabs fill v-model="tabIndex" id="list_tabs">
                <b-overlay :show="show" rounded="sm">
                    <b-tab title-item-class="mytab" v-for="state in states" :key="state" ref="active_tab"
                        @click="getDocs(state)">
                        <template #title>
                            <img class="iconTab" :src="require(`@/assets/${state.replace(/\s/g, '')}.png`)" />
                            {{ state }}
                        </template>
                        <b-container fluid>
                            <b-row>
                                <b-col md="10" xl="5" class="mb-2 pl-md-4">
                                    <div class="fee-noms">
                                        <span>
                                            Firmas disponibles
                                            <span class="text-cid-secondary">{{ nomsAvailable }}</span> de
                                            <span>{{ nomsTotal }}</span>
                                        </span>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="filters">
                                <b-col md="4" xl="3">
                                    <multiselect v-model="setFolder" placeholder="Expedientes"
                                        selectLabel="Presione para seleccionar" deselectLabel="Presione para quitar"
                                        :options="options_folders" :searchable="true">
                                        <span slot="noResult">No hay elementos que mostrar</span>
                                    </multiselect>
                                </b-col>
                                <b-col md="3" xl="2">
                                    <b-form-datepicker v-model="setDate" id="doc_date" placeholder="Fecha"
                                        :reset-button="true" :locale="locale" :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
            }">
                                    </b-form-datepicker>
                                </b-col>
                                <b-col md="4" xl="3">
                                    <multiselect v-model="setTags" placeholder="Filtro"
                                        selectLabel="Presione para seleccionar" deselectLabel="Presione para quitar "
                                        :options="['Titulo', 'Creado', 'Destinatario']" :searchable="false">
                                    </multiselect>
                                </b-col>
                                <b-col md="4" xl="3" offset-md="7" offset-xl="1" class=" filter-doc  my-md-3 my-xl-0">
                                    <b-input-group>
                                        <b-form-input v-model="setSearchFilter" type="search" placeholder="Buscar...">
                                        </b-form-input>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                            <b-table class="mt-4" ref="doc_table" primary-key="name" id="list_files" stacked="md" small
                                hover responsive :items="items" :fields="computedFields" :current-page="currentPage"
                                :per-page="perPage" :filter="filter" :filter-function="filterTable"
                                @filtered="onFiltered" select-mode="single" selectable @row-selected="onRowSelected"
                                show-empty :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                                empty-text="No hay documentos que mostrar"
                                empty-filtered-text="No hay documentos que coincidan con su solicitud">
                                <template v-slot:cell(Fecha)="data">
                                    {{ new Date(data.value) | date('dd/MM/yyyy') }}
                                </template>
                            </b-table>
                            <b-row v-if="items.length" class="justify-content-end mt-4 mb-2">
                                <b-col md="3" lg="2" xl="3">
                                    <b-pagination id="table_pagination" v-model="currentPage" pills prev-text="Anterior"
                                        next-text="Siguiente" :total-rows="totalRows" :per-page="perPage" size="sm"
                                        class="my-0" first-number last-number>
                                    </b-pagination>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-tab>
                    <template v-slot:overlay>
                        <div class="text-center">
                            <b-icon icon="arrow-clockwise" animation="spin" font-scale="2"
                                class="mt-4 text-cid-primary"></b-icon>
                            <p id="cancel-label">Por favor espere...</p>
                        </div>
                    </template>
                </b-overlay>
            </b-tabs>
        </b-container>

        <b-modal id="out-of-credits" hide-header-close>
            <template #modal-title>
                <h3 class="titles">Notificación</h3>
            </template>
            <template #default>
                <b-row class="text-center my-4">
                    <b-col>
                        <p class="lead font-weight-bold">Estimado Usuario,</p>
                        <p class="text-muted">
                            Tu cuenta ha alcanzado el límite de firmas permitido en tu plan. Para continuar disfrutando
                            de
                            <span class="font-italic">ConfidenceID</span>, por favor ponte en contacto con un agente o
                            revisa tu plan actual.
                        </p>
                    </b-col>
                </b-row>
            </template>
            <template #modal-footer>
                <cid-button @click="closeOutOfCredits">Entendido</cid-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import CidButton from '../CidButton.vue';

export default {
    name: 'list',
    components: { Multiselect, CidButton },
    data() {
        return {
            items: [],
            fields: [
                { key: 'Titulo', label: 'TITULO', sortable: true },
                { key: 'Creado', label: 'CREADO', sortable: true },
                { key: 'Destinatario', label: 'DESTINATARIO', sortable: true },
                { key: 'Fecha', label: 'FECHA', sortable: true },
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 50, 100, { value: 100, text: "Todos" }],
            filter: null,
            setSearchFilter: "",
            setFolder: null,
            setDate: "",
            setTags: null,
            filterObject: {
                folder: null,
                date: "",
                tags: null,
                search: ""
            },
            isLoading: false,
            doc_date: null,
            locale: 'es-ES',
            tab_title: "Pendientes",
            show: false,
            states: ['Pendientes', 'En proceso', 'Completado', 'Rechazados'],
            nomsAvailable: 0,
            nomsTotal: 0,
            sortBy: 'Fecha',
            sortDesc: true,
            options_folders: [],
            tabIndex: 0
        }
    },
    watch: {
        tab_title(value) {
            localStorage.tab_title = value;
        },

        setFolder() {
            this.getFolder();
        },
        setDate() {
            this.getDate();
        },
        setTags() {
            this.getTags();
        },
        setSearchFilter() {
            this.getSearch();
        }
    },
    computed: {
        computedFields() {
            if (this.tab_title == "Pendientes")
                return this.fields.filter(field => !field.pendiente);
            else
                return this.fields;
        }
    },
    created() {
        if (!localStorage.tab_title) {
            localStorage.setItem('tab_title', this.tab_title);
        }
        this.getDocs(localStorage.tab_title);
        this.getNomState();
        this.setFoldersOptions();
    },
    mounted() {
        this.totalRows = this.items.length
    },
    methods: {
        isEmptyFilterData() {
            const EMPTY_FOLDER_OR_TAGS = null;
            const EMPTY_DATE_OR_SEARCH = "";
            let response = false;

            if (this.filterObject.folder == EMPTY_FOLDER_OR_TAGS
                && this.filterObject.date == EMPTY_DATE_OR_SEARCH
                && this.filterObject.tags == EMPTY_FOLDER_OR_TAGS
                && this.filterObject.search == EMPTY_DATE_OR_SEARCH) {
                response = true;
            }
            return response;
        },
        getSearch() {
            let _self = this;
            _self.filterObject.search = _self.setSearchFilter;

            if (this.isEmptyFilterData() == false) {
                _self.filter = _self.filterObject;
            } else {
                _self.filter = null;
            }
        },
        getFolder() {
            let _self = this;
            _self.filterObject.folder = _self.setFolder;

            if (this.isEmptyFilterData() == false) {
                _self.filter = _self.filterObject;
            } else {
                _self.filter = null;
            }
        },
        getDate() {
            let _self = this;
            _self.filterObject.date = _self.setDate;

            if (this.isEmptyFilterData() == false) {
                _self.filter = _self.filterObject;
            } else {
                _self.filter = null;
            }
        },
        getTags() {
            let _self = this;
            _self.filterObject.tags = _self.setTags;

            if (this.isEmptyFilterData() == false) {
                _self.filter = _self.filterObject;
            } else {
                _self.filter = null;
            }
        },
        filterTable(row, filter) {
            const FOLDER = row.Carpeta;
            const FECHA = row.Fecha.substring(0, 10);

            const EMPTY_FOLDER_OR_TAGS = null;
            const EMPTY_DATE_OR_SEARCH = "";

            if (filter.folder != EMPTY_FOLDER_OR_TAGS
                && filter.date == EMPTY_DATE_OR_SEARCH
                && filter.tags == EMPTY_FOLDER_OR_TAGS
                && filter.search == EMPTY_DATE_OR_SEARCH) {
                if (FOLDER == filter.folder) {
                    return true;
                } else {
                    return false;
                }
            }

            if (filter.folder == EMPTY_FOLDER_OR_TAGS
                && filter.date != EMPTY_DATE_OR_SEARCH
                && filter.tags == EMPTY_FOLDER_OR_TAGS
                && filter.search == EMPTY_DATE_OR_SEARCH) {
                if (FECHA == filter.date) {
                    return true;
                } else {
                    return false;
                }
            }

            if (filter.folder != EMPTY_FOLDER_OR_TAGS
                && filter.date != EMPTY_DATE_OR_SEARCH
                && filter.tags == EMPTY_FOLDER_OR_TAGS
                && filter.search == EMPTY_DATE_OR_SEARCH) {
                if (FECHA == filter.date && FOLDER == filter.folder) {
                    return true;
                } else {
                    return false;
                }
            }

            if (filter.folder == EMPTY_FOLDER_OR_TAGS
                && filter.date == EMPTY_DATE_OR_SEARCH
                && filter.tags == EMPTY_FOLDER_OR_TAGS
                && filter.search != EMPTY_DATE_OR_SEARCH) {
                if (row.Titulo.includes(filter.search)
                    || row.Creado.includes(filter.search)
                    || row.Destinatario.includes(filter.search)) {
                    return true;
                } else {
                    return false;
                }
            }

            if (filter.folder == EMPTY_FOLDER_OR_TAGS
                && filter.date == EMPTY_DATE_OR_SEARCH
                && filter.tags != EMPTY_FOLDER_OR_TAGS
                && filter.search != EMPTY_DATE_OR_SEARCH) {
                if ((filter.tags == "Titulo" && row.Titulo.includes(filter.search))
                    || (filter.tags == "Creado" && row.Creado.includes(filter.search))
                    || (filter.tags == "Destinatario" && row.Destinatario.includes(filter.search))) {
                    return true;
                } else {
                    return false;
                }
            }
            if (filter.folder == EMPTY_FOLDER_OR_TAGS
                && filter.date != EMPTY_DATE_OR_SEARCH
                && filter.tags != EMPTY_FOLDER_OR_TAGS
                && filter.search != EMPTY_DATE_OR_SEARCH) {
                if (((filter.tags == "Titulo" && row.Titulo.includes(filter.search))
                    || (filter.tags == "Creado" && row.Creado.includes(filter.search))
                    || (filter.tags == "Destinatario" && row.Destinatario.includes(filter.search)))
                    && FECHA == filter.date) {
                    return true;
                } else {
                    return false;
                }
            }
            if (filter.folder != EMPTY_FOLDER_OR_TAGS
                && filter.date != EMPTY_DATE_OR_SEARCH
                && filter.tags != EMPTY_FOLDER_OR_TAGS
                && filter.search != EMPTY_DATE_OR_SEARCH) {
                if (((filter.tags == "Titulo" && row.Titulo.includes(filter.search))
                    || (filter.tags == "Creado" && row.Creado.includes(filter.search))
                    || (filter.tags == "Destinatario" && row.Destinatario.includes(filter.search)))
                    && FECHA == filter.date && FOLDER == filter.folder) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        getDocs(tab_title) {
            switch (localStorage.tab_title) {
                case "Pendientes":
                    this.tabIndex = 0;
                    break;
                case "En proceso":
                    this.tabIndex = 1;
                    break;
                case "Completado":
                    this.tabIndex = 2;
                    break;
                case "Rechazados":
                    this.tabIndex = 3;
                    break;
            }
            this.show = true;
            this.tab_title = tab_title;
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
            axios.get('/api/File/GetFilesList', {
                params: {
                    state: this.tab_title,
                    FechaIn: this.doc_date
                }
            }).then(response => {

                if (response.data.Result == "auth error") this.$router.push({ name: "auth" });

                this.items = response.data.Result;
                this.totalRows = this.items.length;
                this.items.sort((a, b) => new Date(b.Fecha) - new Date(a.Fecha));
                this.show = false;
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        getNomState() {
            axios.get('/api/file/nom-state').then(response => {
                console.log(response);
                console.log("Available: " + response.data.Result.Available);
                console.log("Total: " + response.data.Result.Total);


                this.nomsAvailable = response.data.Result.Total - response.data.Result.Available;

                if (this.nomsAvailable <0 ) {
                    this.$bvModal.show('out-of-credits');
                }

            }).catch(error => {
                console.log(error.response.data)
            });
        },
        closeOutOfCredits() {
            this.$bvModal.hide('out-of-credits');
        },
        setFoldersOptions: function () {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
            axios.get('/api/File/GetFolderList').then(response => {
                this.options_folders = response.data.Result;
            });
        },
        onRowSelected(items) {
            // 3 names view-sign,view-progress, view-signed
            // using tab_title local storage to know the current tab

            console.log(items[0].Id);
            console.log(localStorage.tab_title);

            if (localStorage.tab_title == "Pendientes") {
                this.$router.push({ name: "view-sign", params: { id: items[0].Id } });
            } else if (localStorage.tab_title == "En proceso") {
                this.$router.push({ name: "view-progress", params: { id: items[0].Id } });
            } else if (localStorage.tab_title == "Completado" || localStorage.tab_title == "Rechazados") {
                this.$router.push({ name: "view-signed", params: { id: items[0].Id } });
            }

        }
    }
}
</script>
<style scoped>
/*tabs*/

#list_tabs>>>.nav {
    border: none !important;
    gap: 10px !important;
}

#list_tabs>>>.nav-link {
    background-color: #ffffff !important;
    color: #444A4A;
    font-weight: 600;
    padding: 0.5rem 0.2rem;
    border-bottom: 5px solid #fff;
    border-radius: 0.25rem !important;
}

#list_tabs>>>.mytab .nav-link.active,
#list_tabs>>>.nav-link:hover {
    color: #35495e;
    border-bottom: 5px solid rgb(var(--sidebar-bgcolor)) !important;
}


#list_tabs>>>.tab-content {
    background-color: #fff;
    margin-top: 1rem;
}

#list_tabs>>>.tab-content .tab-pane {
    padding: 1rem;
}


.fee-noms {
    text-align: start;
}

.fee-noms span {
    color: #2E344A;
    font-weight: 600;
    font-size: 14px;
}

img.iconTab {
    width: 50px;
}

/* tabla */
.table>thead>tr>th {
    border-top: 0 !important;
    border-bottom-color: #C1C8C9 !important;
    font-size: 15px;
    color: #2F3044;
}

.table>tbody>tr>td {
    padding: 0.5rem 0.3rem !important;
    font-size: 14px;
    font-weight: 500;
    color: #74818F;
}

.table td {
    border-bottom: 1px solid #ecf2f4;
}



[aria-label="Go to next page"],
[aria-label="Go to previous page"] {
    border: 1px solid #C1C8C9;
    font-weight: 500;
    color: #2e344a !important;
    font-size: 13px !important;
}

.b-pagination-pills .page-item .page-link {
    border-radius: 50rem !important;
    margin-left: 0.25rem;
    line-height: 1;
}

/*filters*/


div#doc_date__outer_ {
    border-radius: 5px !important;
    text-align: start;
    border: 0;
    background: #E1E4E7;
    height: 100%;
}

#doc_date .b-icon {
    font-size: 15px;
    margin-left: 0.5rem;
    color: #2E344A;
}

#doc_date__value_ {
    padding-top: 0.7rem;
    color: #2E344A !important;
    font-size: 13px !important;
    font-weight: 600;
    padding-left: 0;
}

.filter-doc button,
.filter-doc input {
    border: unset;
    border-bottom: 2px solid #ced4da;
    background: #fff;
}

.filter-doc input::placeholder,
.multiselect__placeholder {
    color: #2E344A !important;
    font-size: 13px !important;
    font-weight: 600;
}

.filter-doc button:hover {
    background-color: transparent;
    border-bottom: 2px solid #ced4da;
}

.input-group-append {
    margin-left: unset !important;
}

/*responsive*/
@media only screen and (max-width: 765px) {
    .filters {
        gap: 1rem;
    }

    .filter-doc {
        margin-top: 1rem;
        margin-left: 1.3rem;
        padding-right: 2.4rem !important;
    }

}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
